module.exports = __webpack_public_path__ + "img/example_2.45a19ab4.jpg";